import { useState } from "react";

import styles from "./SignUp.module.css";
import logo from "../../assets/images/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import { useAuth } from "../../context/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const SignUp = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const [user, setUser] = useState({
    name: "",
    mobile_number: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { storeTokenInLS } = useAuth();

  // ERROR HANDELING
  const validateForm = () => {
    const newErrors = {};
    if (!user.name.trim()) {
      newErrors.name = "Name or Number is required";
    }
    if (!user.mobile_number.trim()) {
      newErrors.mobile_number = "mobile number is required";
    }
    if (!user.email.trim()) {
      newErrors.email = "email is required";
    }
    if (!user.password.trim()) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInput = (e) => {
    console.log(e);
    let name = e.target.name;
    let value = e.target.value;

    setUser({
      ...user,
      [name]: value,
    });
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(user);
    setLoading(true);

    if (validateForm()) {
      try {
        const response = await fetch(
          `${MAIN_URL}/api/auth/register`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(user),
          }
        );

        if (response.ok) {
          const res_data = await response.json();
          console.log("res from server", res_data);
          storeTokenInLS(res_data.token);
          setUser({ name: "", mobile_number: "", email: "", password: "" });
          setLoading(false);

          toast.success("Log In Successful!", {
            position: "top-right",
            autoClose: 2000,
          });

          navigate("/login");
        }
      } catch (error) {
        setLoading(false);

        toast.error("An error occurred. Please try again later.");
      }
    } else {
      toast.error("Please fill in all required fields.");
      setLoading(false);
    }
  };
  // LOADING

  return (
    <>
      <div className={styles.signup}>
        <section className={styles.signup_mainContainer}>
          <section className={styles.signup_headContainer}>
            <div className={styles.header}>
              <img className={styles.header_image} src={logo} alt="logo " />
              <div className={styles.header_text}>Musicart</div>
            </div>
          </section>

          <section className={styles.container}>
            <div className={styles.container_heading}>
              <span>Create Account</span>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
              <label className={styles.label} htmlFor="name">
                Your name
              </label>
              <input
                type="text"
                className={styles.input}
                id="name"
                name="name"
                value={user.name}
                onChange={handleInput}
              />
              <div className={styles.error}>{errors.name}</div>
              <label className={styles.label} htmlFor="mobile-number">
                Mobile number
              </label>
              <input
                type="tel"
                className={styles.input}
                id="mobile_number"
                name="mobile_number"
                value={user.mobile_number}
                onChange={handleInput}
              />
              <div className={styles.error}>{errors.mobile_number}</div>

              <label className={styles.label} htmlFor="email">
                Email Id
              </label>
              <input
                type="email"
                className={styles.input}
                id="email"
                name="email"
                value={user.email}
                onChange={handleInput}
              />

              <div className={styles.error}>{errors.email}</div>

              <label className={styles.label} htmlFor="password">
                Password
              </label>
              <input
                type="password"
                className={styles.input}
                id="password"
                name="password"
                value={user.password}
                onChange={handleInput}
              />

              <div className={styles.error}>{errors.password}</div>

              <div className={styles.checkbox_container}>
                By enrolling your mobile phone number, you consent to <br />
                receive automated security notifications via text <br />
                message from Musicart. Message and data rates may <br />
                apply.
              </div>
              <button type="submit" className={styles.signup_btn}>
                {loading ? "Loading..." : "Continue"}
              </button>
            </form>
            <p className={styles.condition}>
              By continuing, you agree to Musicart privacy notice and conditions{" "}
              of use.
            </p>
          </section>

          <div className={styles.signup_footer}>
            <p>
              Already have an account? <NavLink to="/login"> Sign in</NavLink>
            </p>
          </div>
        </section>
        <Footer />
      </div>
      <ToastContainer />

    </>
  );
};

export default SignUp;
